import React, {useCallback} from 'react';
import styled from 'styled-components';

import JsonLogicBuilder from '../../components/JsonLogicBuilder';
import Input from '../../components/Input';

import SubConfiguration from './SubConfiguration';
import {getLogicBuilderVariables} from './shared';

function AggregationElementForm({ form, catalog, element, onChange }) {
  const handleChangeLabel = useCallback(e => {
    onChange({
      ...element,
      data: {
        ...element.data,
        label: e.target.value
      }
    });
  }, [element, onChange]);

  const handleFormulaChange = useCallback(formula => {
    onChange({
      ...element,
      data: {
        ...element.data,
        formula: JSON.stringify(formula)
      }
    });
  }, [element, onChange]);

  const handleDefaultValueChange = useCallback(e => {
    onChange({
      ...element,
      data: {
        ...element.data,
        defaultValue: e.target.value
      }
    });
  }, [element, onChange]);

  const handleAggregationTypeChange = useCallback(e => {
    onChange({
      ...element,
      data: {
        ...element.data,
        aggregation: e.target.value
      }
    });
  }, [element, onChange]);

  const data = normalize(element.data)
  return (
    <>
      <Input
        type="text"
        id={`${element.id}-label`} 
        label="Label"
        defaultValue={data.label}
        onBlur={handleChangeLabel}
      />
      <FormulaLabel>Formula</FormulaLabel>
      <SubConfiguration>
        <SubConfiguration.Item>
          <JsonLogicBuilder
            expand
            variables={getLogicBuilderVariables(form, catalog, null)}
            value={JSON.parse(data.formula)}
            onChange={handleFormulaChange}
          />
        </SubConfiguration.Item>
      </SubConfiguration>
      <Input
        type="select"
        id={`${element.id}-aggregation-type`}
        label="Aggregation type"
        defaultValue={data.aggregation}
        onBlur={handleAggregationTypeChange}>
        <option value="SUM">Sum</option>
        <option value="AVG">Average</option>
        <option value="MIN">Minimum</option>
        <option value="MAX">Maximum</option>
      </Input>
      <Input
        type="number" 
        id={`${element.id}-default-value`} 
        label="Default value"
        helpText="An optional value to display to the user if the formula is not satisfied."
        defaultValue={data.defaultValue}
        onBlur={handleDefaultValueChange}
      />
    </>
  );
}

const elementDefaults = {
  label: '',
  defaultValue: 0,
  aggregation: 'SUM',
  formula: null
};
function normalize(data) {
  return {...elementDefaults, ...data};
}

const FormulaLabel = styled.label`
  display: block;
  margin-top: 0.5rem;
`;

export default AggregationElementForm;